import { render, staticRenderFns } from "./OrderInfoAddress.vue?vue&type=template&id=38a062b6&"
import script from "./OrderInfoAddress.vue?vue&type=script&lang=js&"
export * from "./OrderInfoAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports